export enum WarehousePackageType {
  PALLET = 'Pallet',
  CRATE = 'Crate',
  BOX = 'Box',
}
